import axiosInstance from '@/api/axiosInstance';

export const getCardInfo = async (cardId) => {
  const response = await axiosInstance.get(`/products/${cardId}`);
  return response.data;
};

export const getCardStats = async (cardId) => {
  const response = await axiosInstance.get(`/products/${cardId}/listings/stats`);
  return response.data;
};

export const getNonPsaStats = async (cardId) => {
  const response = await axiosInstance.get(`/products/${cardId}/listings/non-psa/stats`);
  return response.data;
};

export const getCardNonPsaListings = async (id, onSaleOnly = false, condition, sort, direction, cursor = null, limit = 24) => {
  const params = {
    onSaleOnly,
    condition,
    sort,
    direction,
    limit,
    cursor
  };
  const response = await axiosInstance.get(`/products/${id}/listings/no-psa`, { params });
  return response.data;
};

export const getRecentPurchases = async (id, listingType) => {
  const response = await axiosInstance.get(`/products/${id}/purchases/recent`, {
    params: { listingType }
  });
  return response.data;
};

export const getPriceChartData = async (id, params) => {
  const response = await axiosInstance.get(`/products/${id}/purchases/chart`, { params });
  return response.data;
}; 